import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import ScrollToTop from "../components/scroll/ScrollToTop";
import AcessoAplicacao from "./AcessoAplicacao";

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <ScrollToTop />
      <AcessoAplicacao>
        <Routes />
      </AcessoAplicacao>
    </Router>
  );
}

export default App;
